import React, { useEffect, useState } from "react";
import { db } from "../firebaseConfig.js";
import {
  collection, query, onSnapshot, orderBy, addDoc, Timestamp,
} from "firebase/firestore";
import styled, { keyframes, css } from "styled-components";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FlightIcon from "@mui/icons-material/Flight";
import HotelIcon from "@mui/icons-material/Hotel";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import BadgeIcon from "@mui/icons-material/Badge";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ReplayIcon from "@mui/icons-material/Replay";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
// ─── Helpers ──────────────────────────────────────────────────────────────────

const fmtDate = (str) =>
  str ? new Date(str).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—";
const fmtGBP  = (n) => `£ ${parseFloat(n || 0).toFixed(2)}`;
const fmtUSD  = (n) => `$ ${parseFloat(n || 0).toFixed(2)}`;
const fmtPKR  = (n) => `RS ${parseFloat(n || 0).toFixed(2)}`;
const initials = (name) => (name || "?").split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();

// ─── Section Config ───────────────────────────────────────────────────────────

const SECTIONS = [
  { key: "credits",   label: "Credits",             icon: <AccountBalanceWalletIcon />, accent: "#2563eb", light: "#eff6ff" },
  { key: "flights",   label: "Flights",             icon: <FlightIcon />,               accent: "#0891b2", light: "#ecfeff" },
  { key: "hotels",    label: "Hotels",              icon: <HotelIcon />,                accent: "#7c3aed", light: "#f5f3ff" },
  { key: "transport", label: "Transport",           icon: <DirectionsBusIcon />,        accent: "#059669", light: "#ecfdf5" },
  { key: "visa",      label: "Visa",                icon: <BadgeIcon />,                accent: "#d97706", light: "#fffbeb" },
  { key: "refunds",   label: "Customer Refunds",    icon: <ReplayIcon />,               accent: "#dc2626", light: "#fef2f2" },
  { key: "invoiced",  label: "Previously Invoiced", icon: <ReceiptLongIcon />,          accent: "#64748b", light: "#f8fafc" },
];

// ─── Sub-components ───────────────────────────────────────────────────────────

const CollapsibleTable = ({ sectionKey, label, icon, accent, light, columns, rows, totalLabel, totalValue, open, onToggle }) => (
  <SectionBlock>
    <SectionHead accent={accent} onClick={onToggle}>
      <HeadLeft>
        <IconWrap accent={accent}>{icon}</IconWrap>
        <span>{label}</span>
      </HeadLeft>
      <HeadRight>
        <TotalPill accent={accent}>{fmtGBP(totalValue)}</TotalPill>
        {open ? <KeyboardArrowUpIcon style={{ fontSize: 22, opacity: 0.7 }} /> : <KeyboardArrowDownIcon style={{ fontSize: 22, opacity: 0.7 }} />}
      </HeadRight>
    </SectionHead>

    {open && (
      <TableWrap light={light}>
        <table className="inner-table">
          <thead>
            <tr>
              <th>#</th>
              {columns.map(c => <th key={c}>{c}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={columns.length + 1} className="empty-row">No entries for this folder</td></tr>
            ) : (
              rows.map((row, idx) => (
                <tr key={row.id} className={idx % 2 === 0 ? "even" : "odd"}>
                  <td className="sr">{idx + 1}</td>
                  {row.cells.map((cell, ci) => <td key={ci}>{cell}</td>)}
                </tr>
              ))
            )}
            {rows.length > 0 && (
              <tr className="total-row">
                <td colSpan={columns.length} className="total-label">{totalLabel}</td>
                <td className="total-val">{fmtGBP(totalValue)}</td>
              </tr>
            )}
          </tbody>
        </table>
      </TableWrap>
    )}
  </SectionBlock>
);

// ─── Main Component ───────────────────────────────────────────────────────────

const FolderLedger = ({ FolderNumber }) => {


  
const location = useLocation();

  const [searchParams] = useSearchParams();
  const FolderNumber1 = searchParams.get("FolderNumber");

  console.log("RECEIVED THIS");
  console.log(FolderNumber1);
  const [isNavigated,    setisNavigated]    = useState(false);


  const [folderSearch,    setFolderSearch]    = useState("");
  const [activeFolder,    setActiveFolder]    = useState("");
  const [credits,         setCredits]         = useState([]);
  const [flights,         setFlights]         = useState([]);
  const [hotels,          setHotels]          = useState([]);
  const [transport,       setTransport]       = useState([]);
  const [visa,            setVisa]            = useState([]);
  const [customerrefund,  setcustomerrefund]  = useState([]);
  const [invoiced,        setInvoiced]        = useState([]);
  const [invoiceModalOpen,setInvoiceModalOpen]= useState(false);
  const [invoiceRemarks,  setInvoiceRemarks]  = useState("");
  const [invoiceType,     setInvoiceType]     = useState("Final");
  const [invoiceAmount,   setInvoiceAmount]   = useState(0);
  const [openSections,    setOpenSections]    = useState({ credits: true, flights: true, hotels: true, transport: true, visa: true, refunds: true, invoiced: true });

  useEffect(() => {
    const fetchData = (col, setter) => {
      const q = query(collection(db, col), orderBy("timestamp", "desc"));
      return onSnapshot(q, (snap) => setter(snap.docs.map(d => ({ id: d.id, ...d.data(), timestamp: d.data().timestamp?.toDate?.() ?? new Date() }))));
    };
    const unsubs = [
      fetchData("bankPayments",          setCredits),
      fetchData("flightSupplierLedger",  setFlights),
      fetchData("hotelSupplierLedger",   setHotels),
      fetchData("transportSupplierLedger",setTransport),
      fetchData("visaSupplierLedger",    setVisa),
      fetchData("invoiced",              setInvoiced),
      fetchData("customerRefunds",       setcustomerrefund),
    ];
    return () => unsubs.forEach(u => u());
  }, []);


  //  useEffect(() => {

  //   FolderNumber = "393";
  //   if(FolderNumber != ""){
  //       setFolderSearch(FolderNumber)
  //   }
  //   handleSearch();
  // }, []);

  useEffect(() => {

  if (FolderNumber1 !== "") {
    setFolderSearch(FolderNumber1);
    setisNavigated(true)
  }

}, [FolderNumber1]);

useEffect(() => {
    handleSearch();
    console.log("SEARCHED")
    // setisNavigated(false)
}, [folderSearch]);







  const filterBy = (arr) =>
    activeFolder ? arr.filter(e => (e.folderNo || "").toLowerCase() === activeFolder) : [];

  const folderCredits   = filterBy(credits);
  const folderFlights   = filterBy(flights);
  const folderHotels    = filterBy(hotels);
  const folderTransport = filterBy(transport);
  const folderVisa      = filterBy(visa);
  const folderInvoiced  = filterBy(invoiced);
  const folderRefunds   = filterBy(customerrefund);

  const totalCredits  = folderCredits.reduce((s, c) => s + parseFloat(c.paymentGBP || 0), 0);
  const totalFlights  = folderFlights.reduce((s, f) => s + parseFloat(f.cost || 0), 0);
  const totalHotels   = folderHotels.reduce((s, h) => s + parseFloat(h.cost || 0), 0);
  const totalTransport= folderTransport.reduce((s, t) => s + parseFloat(t.cost || 0), 0);
  const totalVisa     = folderVisa.reduce((s, v) => s + parseFloat(v.cost || 0), 0);
  const totalRefunds  = folderRefunds.reduce((s, r) => s + parseFloat(r.amountGBP || 0), 0);
  const totalInvoiced = folderInvoiced.reduce((s, i) => s + parseFloat(i.amount || 0), 0);
  const totalDebits   = totalFlights + totalHotels + totalTransport + totalVisa + totalInvoiced + totalRefunds;
  const remaining     = totalCredits - totalDebits;

  const handleSearch = () => setActiveFolder(folderSearch);
  const handleClear  = () => { setFolderSearch(""); setActiveFolder(""); };
  const toggleSection = (key) => setOpenSections(p => ({ ...p, [key]: !p[key] }));

  const handleInvoice = async () => {
    if (!invoiceRemarks) return alert("Enter remarks");
    const newInvoice = {
      agent: folderCredits[0]?.agent || folderFlights[0]?.agent || "",
      folderNo: activeFolder,
      amount: invoiceType === "Partial" ? invoiceAmount : remaining,
      reason: invoiceType,
      date: new Date().toISOString().split("T")[0],
      remarks: invoiceRemarks,
      timestamp: Timestamp.now(),
    };
    try {
      await addDoc(collection(db, "invoiced"), newInvoice);
      alert("Folder invoiced successfully");
      setInvoiceModalOpen(false);
      setInvoiceRemarks("");
      setInvoiceType("Final");
    } catch { alert("Failed to invoice folder"); }
  };

  const hasData = activeFolder && (
    folderCredits.length + folderFlights.length + folderHotels.length +
    folderTransport.length + folderVisa.length + folderRefunds.length + folderInvoiced.length > 0
  );

  useEffect(() => {
    if(hasData){
        setisNavigated(false)
    }

}, [hasData]);

  // ── Table row builders ──────────────────────────────────────────────────────

  const creditRows = folderCredits.map(c => ({
    id: c.id,
    cells: [
      <AgentCell><Avatar>{initials(c.agent)}</Avatar>{c.agent}</AgentCell>,
      <Chip mono>{c.folderNo || "—"}</Chip>,
      <strong style={{ color: "#2563eb" }}>{fmtGBP(c.paymentGBP)}</strong>,
      c.paymentPKR ? fmtPKR(c.paymentPKR) : "—",
      c.paymentUSD ? fmtUSD(c.paymentUSD) : "—",
      c.rate || "—",
      <span style={{ fontFamily: "monospace", fontSize: 12 }}>{c.reference}</span>,
      <BankBadge>{c.bankName}</BankBadge>,
      fmtDate(c.date),
      <Muted>{c.remarks || "—"}</Muted>,
    ],
  }));

  const flightRows = folderFlights.map(f => ({
    id: f.id,
    cells: [
      <AgentCell><Avatar>{initials(f.agent)}</Avatar>{f.agent}</AgentCell>,
      <Chip mono>{f.folderNo}</Chip>,
      <span style={{ fontFamily: "monospace" }}>{f.pnr || "—"}</span>,
      <strong style={{ color: "#dc3545" }}>{fmtGBP(f.cost)}</strong>,
      f.supplier || "—",
      fmtDate(f.issuanceDate),
      fmtDate(f.travelDate),
      <Muted>{f.issuedBy || "—"}</Muted>,
      <TypeBadge>{f.type || "—"}</TypeBadge>,
      <Muted>{f.remarks || "—"}</Muted>,
    ],
  }));

  const hotelRows = folderHotels.map(h => ({
    id: h.id,
    cells: [
      <AgentCell><Avatar>{initials(h.agent)}</Avatar>{h.agent}</AgentCell>,
      <Chip mono>{h.folderNo}</Chip>,
      <span style={{ fontFamily: "monospace", fontSize: 12 }}>{h.bookingRef || "—"}</span>,
      <strong style={{ color: "#dc3545" }}>{fmtGBP(h.cost)}</strong>,
      h.supplier || "—",
      fmtDate(h.checkInDate),
      fmtDate(h.cancellationDate),
      <Muted>{h.issuedBy || "—"}</Muted>,
      <Muted>{h.remarks || "—"}</Muted>,
    ],
  }));

  const transportRows = folderTransport.map(t => ({
    id: t.id,
    cells: [
      <AgentCell><Avatar>{initials(t.agent)}</Avatar>{t.agent}</AgentCell>,
      <Chip mono>{t.folderNo}</Chip>,
      t.legs || "—",
      <strong style={{ color: "#dc3545" }}>{fmtGBP(t.cost)}</strong>,
      t.supplier || "—",
      fmtDate(t.date),
      <Muted>{t.issuedBy || "—"}</Muted>,
      <Muted>{t.remarks || "—"}</Muted>,
    ],
  }));

  const visaRows = folderVisa.map(v => ({
    id: v.id,
    cells: [
      <AgentCell><Avatar>{initials(v.agent)}</Avatar>{v.agent}</AgentCell>,
      <Chip mono>{v.folderNo}</Chip>,
      <TypeBadge>{v.type || "—"}</TypeBadge>,
      <strong style={{ color: "#dc3545" }}>{fmtGBP(v.cost)}</strong>,
      v.supplier || "—",
      fmtDate(v.date),
      <Muted>{v.issuedBy || "—"}</Muted>,
      <Muted>{v.remarks || "—"}</Muted>,
    ],
  }));

  const refundRows = folderRefunds.map(r => ({
    id: r.id,
    cells: [
      <AgentCell><Avatar>{initials(r.agent)}</Avatar>{r.agent}</AgentCell>,
      <Chip mono>{r.folderNo}</Chip>,
      <BankBadge>{r.bank || "—"}</BankBadge>,
      <strong style={{ color: "#dc3545" }}>{fmtGBP(r.amountGBP)}</strong>,
      r.currency || "—",
      r.reason || "—",
      <Muted>{r.refundedBy || "—"}</Muted>,
      fmtDate(r.date),
    ],
  }));

  const invoicedRows = folderInvoiced.map(i => ({
    id: i.id,
    cells: [
      <AgentCell><Avatar>{initials(i.agent)}</Avatar>{i.agent}</AgentCell>,
      <Chip mono>{i.folderNo}</Chip>,
      <strong style={{ color: "#dc3545" }}>{fmtGBP(i.amount)}</strong>,
      <TypeBadge>{i.reason || "—"}</TypeBadge>,
      fmtDate(i.date),
      <Muted>{i.remarks || "—"}</Muted>,
    ],
  }));

  return (
    <Page>
      {/* ── Header ── */}
      <PageTitle>Folder Summary</PageTitle>

      {/* ── Search Bar ── */}
      <SearchCard>
        <SearchRow>
          <SearchInputWrap>
            <SearchIcon style={{ color: "#94a3b8", fontSize: 18, flexShrink: 0 }} />
            <SearchInput
              placeholder="Enter folder number…"
              value={folderSearch}
              onChange={e => setFolderSearch(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleSearch()}
            />
            {folderSearch && (
              <ClearBtn onClick={handleClear}><ClearIcon style={{ fontSize: 16 }} /></ClearBtn>
            )}
          </SearchInputWrap>
          <SearchButton onClick={handleSearch}>Search</SearchButton>
          {activeFolder && remaining !== 0 && (
            <InvoiceButton onClick={() => setInvoiceModalOpen(true)}>
              <CheckCircleOutlineIcon style={{ fontSize: 16 }} />
              Invoice Folder
            </InvoiceButton>
          )}
        </SearchRow>

        {activeFolder && (
          <BalanceBanner positive={remaining >= 0}>
            <BalanceRow>
              <BalanceItem>
                <BalanceLabel>Total Credits</BalanceLabel>
                <BalanceValue color="#2563eb">{fmtGBP(totalCredits)}</BalanceValue>
              </BalanceItem>
              <Divider />
              <BalanceItem>
                <BalanceLabel>Total Debits</BalanceLabel>
                <BalanceValue color="#dc3545">{fmtGBP(totalDebits)}</BalanceValue>
              </BalanceItem>
              <Divider />
              <BalanceItem>
                <BalanceLabel>Remaining Balance</BalanceLabel>
                <BalanceValue color={remaining >= 0 ? "#059669" : "#dc2626"} large>
                  {fmtGBP(remaining)}
                </BalanceValue>
              </BalanceItem>
            </BalanceRow>
          </BalanceBanner>
        )}
      </SearchCard>

      {/* ── Empty State ── */}
      {!activeFolder && (
        <EmptyState>
          <EmptyIcon>🗂</EmptyIcon>
          <EmptyTitle>Enter a folder number to get started</EmptyTitle>
          <EmptySubtitle>Search by folder number to view all credits, debits, and balance for that booking.</EmptySubtitle>
        </EmptyState>
      )}

      {activeFolder && !hasData && !isNavigated && (
        <EmptyState>
          <EmptyIcon>🔍</EmptyIcon>
          <EmptyTitle>No data found for "{activeFolder}"</EmptyTitle>
          <EmptySubtitle>Double-check the folder number and try again.</EmptySubtitle>
        </EmptyState>
      )}

{activeFolder &&
<>
 {isNavigated && (
        <EmptyState>
          <EmptyIcon>🔍</EmptyIcon>
          <EmptyTitle>Searching "{activeFolder}"</EmptyTitle>
          {/* <EmptySubtitle>Double-check the folder number and try again.</EmptySubtitle> */}
        </EmptyState>
      )}
      </>
}
     

      {/* ── Tables ── */}
      {hasData && (
        <TablesArea>
          <CollapsibleTable
            sectionKey="credits"
            label="Credits"
            icon={<AccountBalanceWalletIcon style={{ fontSize: 18 }} />}
            accent="#2563eb" light="#eff6ff"
            columns={["Agent", "Folder", "Payment (GBP)", "PKR", "USD", "Rate", "Reference", "Bank", "Date", "Remarks"]}
            rows={creditRows}
            totalLabel="Total Credits"
            totalValue={totalCredits}
            open={openSections.credits}
            onToggle={() => toggleSection("credits")}
          />

          <CollapsibleTable
            sectionKey="flights"
            label="Flights"
            icon={<FlightIcon style={{ fontSize: 18 }} />}
            accent="#0891b2" light="#ecfeff"
            columns={["Agent", "Folder", "PNR", "Cost", "Supplier", "Issuance Date", "Travel Date", "Issued By", "Type", "Ticket Order"]}
            rows={flightRows}
            totalLabel="Total Flight Debits"
            totalValue={totalFlights}
            open={openSections.flights}
            onToggle={() => toggleSection("flights")}
          />

          <CollapsibleTable
            sectionKey="hotels"
            label="Hotels"
            icon={<HotelIcon style={{ fontSize: 18 }} />}
            accent="#7c3aed" light="#f5f3ff"
            columns={["Agent", "Folder", "Booking Ref", "Cost", "Supplier", "Check In", "Cancellation", "Issued By", "Ticket Order"]}
            rows={hotelRows}
            totalLabel="Total Hotel Debits"
            totalValue={totalHotels}
            open={openSections.hotels}
            onToggle={() => toggleSection("hotels")}
          />

          <CollapsibleTable
            sectionKey="transport"
            label="Transport"
            icon={<DirectionsBusIcon style={{ fontSize: 18 }} />}
            accent="#059669" light="#ecfdf5"
            columns={["Agent", "Folder", "Legs", "Cost", "Supplier", "Date", "Issued By", "Ticket Order"]}
            rows={transportRows}
            totalLabel="Total Transport Debits"
            totalValue={totalTransport}
            open={openSections.transport}
            onToggle={() => toggleSection("transport")}
          />

          <CollapsibleTable
            sectionKey="visa"
            label="Visa"
            icon={<BadgeIcon style={{ fontSize: 18 }} />}
            accent="#d97706" light="#fffbeb"
            columns={["Agent", "Folder", "Type", "Cost", "Supplier", "Date", "Issued By", "Ticket Order"]}
            rows={visaRows}
            totalLabel="Total Visa Debits"
            totalValue={totalVisa}
            open={openSections.visa}
            onToggle={() => toggleSection("visa")}
          />

          <CollapsibleTable
            sectionKey="refunds"
            label="Customer Refunds"
            icon={<ReplayIcon style={{ fontSize: 18 }} />}
            accent="#dc2626" light="#fef2f2"
            columns={["Agent", "Folder", "Bank", "Amount (GBP)", "Currency", "Reason", "Refunded By", "Date"]}
            rows={refundRows}
            totalLabel="Total Refund Debits"
            totalValue={totalRefunds}
            open={openSections.refunds}
            onToggle={() => toggleSection("refunds")}
          />

          <CollapsibleTable
            sectionKey="invoiced"
            label="Previously Invoiced"
            icon={<ReceiptLongIcon style={{ fontSize: 18 }} />}
            accent="#64748b" light="#f8fafc"
            columns={["Agent", "Folder", "Amount", "Type", "Date", "Remarks"]}
            rows={invoicedRows}
            totalLabel="Total Invoiced"
            totalValue={totalInvoiced}
            open={openSections.invoiced}
            onToggle={() => toggleSection("invoiced")}
          />
        </TablesArea>
      )}

      {/* ── Invoice Modal ── */}
      {invoiceModalOpen && (
        <ModalOverlay onClick={() => setInvoiceModalOpen(false)}>
          <ModalBox onClick={e => e.stopPropagation()}>
            <ModalHeader>
              <div>
                <ModalTitle>Invoice Folder</ModalTitle>
                <ModalSub>Folder #{activeFolder}</ModalSub>
              </div>
              <CloseBtn onClick={() => setInvoiceModalOpen(false)}>
                <ClearIcon style={{ fontSize: 18 }} />
              </CloseBtn>
            </ModalHeader>

            <BalanceLine>
              <span style={{ color: "#64748b" }}>Remaining Balance</span>
              <span style={{ fontWeight: 700, fontSize: 20, color: remaining >= 0 ? "#059669" : "#dc2626" }}>
                {fmtGBP(remaining)}
              </span>
            </BalanceLine>

            <ModalField>
              <ModalLabel>Invoice Type</ModalLabel>
              <ModalSelect value={invoiceType} onChange={e => setInvoiceType(e.target.value)}>
                <option value="Final">Final Closing</option>
                <option value="Partial">Partial Closing</option>
              </ModalSelect>
            </ModalField>

            {invoiceType === "Partial" && (
              <ModalField>
                <ModalLabel>Amount to Close</ModalLabel>
                <ModalInput
                  type="number"
                  value={invoiceAmount}
                  onChange={e => setInvoiceAmount(Number(e.target.value))}
                  placeholder="Enter amount"
                />
                <ModalHint>Cannot exceed {fmtGBP(remaining)}</ModalHint>
              </ModalField>
            )}

            <ModalField>
              <ModalLabel>Remarks</ModalLabel>
              <ModalTextarea
                rows={3}
                value={invoiceRemarks}
                onChange={e => setInvoiceRemarks(e.target.value)}
                placeholder="Add remarks…"
              />
            </ModalField>

            <ModalActions>
              <CancelBtn onClick={() => setInvoiceModalOpen(false)}>Cancel</CancelBtn>
              <ConfirmBtn
                onClick={handleInvoice}
                disabled={invoiceType === "Partial" && (invoiceAmount <= 0 || invoiceAmount > remaining)}
              >
                <CheckCircleOutlineIcon style={{ fontSize: 16 }} />
                Confirm Invoice
              </ConfirmBtn>
            </ModalActions>
          </ModalBox>
        </ModalOverlay>
      )}
    </Page>
  );
};

// ─── Small Atoms ─────────────────────────────────────────────────────────────

const AgentCell = styled.div`
  display: flex; align-items: center; gap: 7px;
`;
const Avatar = styled.div`
  width: 26px; height: 26px; border-radius: 50%;
  background: #dbeafe; color: #1e40af;
  display: flex; align-items: center; justify-content: center;
  font-size: 10px; font-weight: 600; flex-shrink: 0;
`;
const Chip = styled.span`
  display: inline-flex; align-items: center;
  background: #f3f4f6; border: 0.5px solid #d1d5db;
  border-radius: 4px; padding: 2px 7px;
  font-size: 12px; font-family: ${p => p.mono ? "monospace" : "inherit"}; color: #374151;
`;
const BankBadge = styled.span`
  display: inline-flex; align-items: center;
  background: #f0fdf4; border: 0.5px solid #86efac;
  border-radius: 4px; padding: 2px 8px;
  font-size: 11px; font-weight: 600; color: #166534; letter-spacing: 0.4px;
`;
const TypeBadge = styled.span`
  display: inline-flex; align-items: center;
  background: #ede9fe; border: 0.5px solid #c4b5fd;
  border-radius: 4px; padding: 2px 7px;
  font-size: 11px; font-weight: 600; color: #5b21b6; letter-spacing: 0.4px;
`;
const Muted = styled.span`color: #94a3b8; font-size: 12px;`;

// ─── Layout ────────────────────────────────────────────────────────────────────

const fadeIn = keyframes`from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; }`;

const Page = styled.div`
  padding: 2rem;
  max-width: 1300px;
  margin: 25px auto 0;
`;

const PageTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: #2563eb;
  background: #e0f2fe;
  display: inline-block;
  padding: 8px 20px;
  border-radius: 8px;
  margin-bottom: 24px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  letter-spacing: 0.5px;
`;

// ─── Search ────────────────────────────────────────────────────────────────────

const SearchCard = styled.div`
  background: white;
  border: 0.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
`;
const SearchRow = styled.div`
  display: flex; gap: 12px; align-items: center; flex-wrap: wrap;
`;
const SearchInputWrap = styled.div`
  display: flex; align-items: center; gap: 10px;
  flex: 1; min-width: 220px;
  border: 2px solid #e2e8f0; border-radius: 8px;
  padding: 0 12px; background: #f8fafc;
  transition: border-color 0.2s;
  &:focus-within { border-color: #2563eb; background: white; }
`;
const SearchInput = styled.input`
  flex: 1; border: none; background: transparent; outline: none;
  padding: 10px 0; font-size: 14px; color: #1e293b;
  &::placeholder { color: #94a3b8; }
`;
const ClearBtn = styled.button`
  border: none; background: none; cursor: pointer;
  color: #94a3b8; display: flex; align-items: center;
  padding: 0; &:hover { color: #64748b; }
`;
const SearchButton = styled.button`
  padding: 10px 20px; background: #2563eb; color: white;
  border: none; border-radius: 8px; font-size: 14px; font-weight: 600;
  cursor: pointer; transition: background 0.2s;
  &:hover { background: #1d4ed8; }
`;
const InvoiceButton = styled.button`
  display: flex; align-items: center; gap: 6px;
  padding: 10px 18px; background: #059669; color: white;
  border: none; border-radius: 8px; font-size: 14px; font-weight: 600;
  cursor: pointer; transition: background 0.2s;
  &:hover { background: #047857; }
`;

// ─── Balance Banner ────────────────────────────────────────────────────────────

const BalanceBanner = styled.div`
  margin-top: 16px;
  background: ${p => p.positive ? "#f0fdf4" : "#fef2f2"};
  border: 1px solid ${p => p.positive ? "#bbf7d0" : "#fecaca"};
  border-radius: 10px;
  padding: 16px 24px;
  animation: ${fadeIn} 0.3s ease;
`;
const BalanceRow = styled.div`
  display: flex; align-items: center; flex-wrap: wrap; gap: 8px;
`;
const BalanceItem = styled.div`
  display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 120px;
`;
const BalanceLabel = styled.span`
  font-size: 11px; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.6px; color: #64748b;
`;
const BalanceValue = styled.span`
  font-size: ${p => p.large ? "22px" : "18px"};
  font-weight: 700;
  color: ${p => p.color || "#111"};
  font-variant-numeric: tabular-nums;
`;
const Divider = styled.div`
  width: 1px; height: 40px; background: #e2e8f0; margin: 0 8px;
`;

// ─── Empty ────────────────────────────────────────────────────────────────────

const EmptyState = styled.div`
  text-align: center; padding: 64px 24px;
  background: white; border-radius: 12px;
  border: 0.5px solid #e2e8f0;
  animation: ${fadeIn} 0.3s ease;
`;
const EmptyIcon = styled.div`font-size: 48px; margin-bottom: 16px;`;
const EmptyTitle = styled.div`font-size: 18px; font-weight: 600; color: #1e293b; margin-bottom: 8px;`;
const EmptySubtitle = styled.div`font-size: 14px; color: #94a3b8; max-width: 360px; margin: 0 auto;`;

// ─── Tables Area ──────────────────────────────────────────────────────────────

const TablesArea = styled.div`
  display: flex; flex-direction: column; gap: 16px;
  animation: ${fadeIn} 0.35s ease;
`;

const SectionBlock = styled.div`
  border-radius: 10px;
  border: 0.5px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
`;

const SectionHead = styled.div`
  display: flex; justify-content: space-between; align-items: center;
  padding: 13px 18px;
  background: white;
  border-left: 4px solid ${p => p.accent || "#2563eb"};
  cursor: pointer; user-select: none;
  transition: background 0.15s;
  &:hover { background: #f8fafc; }
`;
const HeadLeft = styled.div`
  display: flex; align-items: center; gap: 10px;
  font-size: 15px; font-weight: 600; color: #1e293b;
`;
const IconWrap = styled.div`
  display: flex; align-items: center; justify-content: center;
  width: 30px; height: 30px; border-radius: 6px;
  background: ${p => p.accent}18;
  color: ${p => p.accent};
`;
const HeadRight = styled.div`
  display: flex; align-items: center; gap: 10px;
`;
const TotalPill = styled.span`
  background: ${p => p.accent}15;
  color: ${p => p.accent};
  border: 1px solid ${p => p.accent}30;
  border-radius: 20px; padding: 2px 12px;
  font-size: 13px; font-weight: 700;
`;

const TableWrap = styled.div`
  overflow-x: auto;
  background: ${p => p.light || "#fafafa"};
  border-top: 0.5px solid #e2e8f0;

  .inner-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    min-width: 700px;

    thead tr {
      background: white;
      border-bottom: 1px solid #e2e8f0;
    }
    th {
      padding: 9px 12px;
      text-align: left;
      font-size: 11px;
      font-weight: 600;
      color: #94a3b8;
      letter-spacing: 0.6px;
      text-transform: uppercase;
      white-space: nowrap;
    }
    th:first-child { padding-left: 18px; width: 36px; }

    td {
      padding: 10px 12px;
      vertical-align: middle;
      border-bottom: 0.5px solid #f1f5f9;
    }
    td:first-child { padding-left: 18px; color: #cbd5e1; font-size: 12px; }

    tr.even td { background: white; }
    tr.odd  td { background: #fafafa; }
    tr:hover td { background: #eff6ff !important; transition: background 0.1s; }

    .sr { color: #94a3b8; font-size: 11px; }

    .empty-row {
      text-align: center;
      padding: 28px;
      color: #94a3b8;
      font-size: 13px;
      font-style: italic;
    }

    .total-row td {
      background: #f1f5f9 !important;
      border-top: 1px solid #e2e8f0;
      border-bottom: none;
      font-weight: 600;
      font-size: 13px;
      color: #475569;
    }
    .total-label {
      text-align: right;
      padding-right: 16px;
      color: #64748b;
      font-style: italic;
    }
    .total-val { color: #1e293b; font-size: 14px; font-weight: 700; }
  }
`;

// ─── Modal ─────────────────────────────────────────────────────────────────────

const ModalOverlay = styled.div`
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex; align-items: center; justify-content: center;
  z-index: 1000;
`;
const ModalBox = styled.div`
  background: white;
  border-radius: 14px;
  padding: 28px;
  width: min(480px, 94vw);
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  animation: ${fadeIn} 0.2s ease;
`;
const ModalHeader = styled.div`
  display: flex; justify-content: space-between; align-items: flex-start;
  margin-bottom: 20px;
`;
const ModalTitle = styled.div`font-size: 18px; font-weight: 700; color: #1e293b;`;
const ModalSub   = styled.div`font-size: 13px; color: #94a3b8; margin-top: 2px;`;
const CloseBtn   = styled.button`
  width: 30px; height: 30px; border-radius: 6px;
  border: 0.5px solid #e2e8f0; background: white;
  cursor: pointer; color: #64748b;
  display: flex; align-items: center; justify-content: center;
  &:hover { background: #fee2e2; color: #dc3545; }
`;
const BalanceLine = styled.div`
  display: flex; justify-content: space-between; align-items: center;
  background: #f8fafc; border: 0.5px solid #e2e8f0;
  border-radius: 8px; padding: 12px 16px;
  margin-bottom: 20px; font-size: 14px; font-weight: 500;
`;
const ModalField = styled.div`
  display: flex; flex-direction: column; gap: 6px; margin-bottom: 16px;
`;
const ModalLabel = styled.label`
  font-size: 12px; font-weight: 600; color: #64748b;
  text-transform: uppercase; letter-spacing: 0.5px;
`;
const inputStyles = `
  padding: 10px 12px; font-size: 14px;
  border: 2px solid #e2e8f0; border-radius: 8px;
  outline: none; background: white; color: #1e293b;
  transition: border-color 0.2s;
  &:focus { border-color: #2563eb; }
`;
const ModalSelect   = styled.select`${inputStyles} width: 100%; cursor: pointer;`;
const ModalInput    = styled.input`${inputStyles} width: 100%; box-sizing: border-box;`;
const ModalTextarea = styled.textarea`${inputStyles} width: 100%; box-sizing: border-box; resize: vertical; font-family: inherit;`;
const ModalHint     = styled.div`font-size: 11px; color: #94a3b8;`;
const ModalActions  = styled.div`display: flex; gap: 10px; margin-top: 24px;`;
const CancelBtn     = styled.button`
  flex: 1; padding: 11px; border: 1px solid #e2e8f0;
  background: white; border-radius: 8px; font-size: 14px; font-weight: 600;
  color: #64748b; cursor: pointer;
  &:hover { background: #f8fafc; }
`;
const ConfirmBtn = styled.button`
  flex: 2; padding: 11px; background: #059669; color: white;
  border: none; border-radius: 8px; font-size: 14px; font-weight: 600;
  cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 6px;
  transition: background 0.2s;
  &:hover:not(:disabled) { background: #047857; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export default FolderLedger;